import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProductCarousel from './ProductCarousel';
import { showProductDetails } from '../../actions/productDetails';
import { toggleProductFavorite } from '../../actions/routines';

const ProductCarouselContainer = ({
    title,
    subtitle,
    products,
    showProductDetails,
    toggleProductFavorite,
    handleActionCarousel,
}) => {
    return (
        <ProductCarousel
            title={title}
            subtitle={subtitle}
            products={products}
            openProductDetails={showProductDetails}
            toggleProductFavorite={toggleProductFavorite}
            handleActionCarousel={handleActionCarousel}
        />
    );
};

const mapStateToProps = (state) => ({
    // Add any state mappings if needed in the future
});

const mapDispatchToProps = (dispatch) => ({
    showProductDetails: bindActionCreators(showProductDetails, dispatch),
    toggleProductFavorite: bindActionCreators(toggleProductFavorite, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductCarouselContainer);
